function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.trim().split('=');
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

export function getRequestHeaders() {
  const headers = {
    'X-CSRFToken': getCookie('csrftoken'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  return headers;
}

export const getApiBaseUrl = () => {
  const env = process.env.NODE_ENV;

  if (env === 'production') {
    return 'https://api.consili.io';
  } else if (env === 'development') {
    return 'http://api-local.consili.io:8000';
  } else {
    return `http://api-${env}.consili.io`;
  }
};

export const getUserRequestHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
});
